$(document).ready(function () {
  // console.log("product-slider.js");
  $(".product-card-slider").slick({
    arrows: false,
    dots: false,
    fade: true,
    speed: 100,
    swipeToSlide: true,
    loop: false,
    infinite: false,
  });

  $(".home-slider").slick({
    arrows: false,
    dots: false,
    speed: 250,
    swipeToSlide: false,
    loop: true,
    infinite: true,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          variableWidth: false,
        },
      },
    ],
  });

  $(".card__color-swatch").on("click", (e) => {
    var imageIndex = e.srcElement.dataset.index;
    var carouselId = e.srcElement.dataset.carousel;
    var oldSw = $(".card__color-swatch").filter(function () {
      return $(this).data("carousel") == carouselId;
    });
    var sw = $(".card__color-swatch").filter(function () {
      return (
        $(this).data("index") == imageIndex &&
        $(this).data("carousel") == carouselId
      );
    });
    oldSw.removeClass("active");
    sw.addClass("active");
    // $(`[data-carousel=${carouselId}]`).removeClass("active");
    // console.log("go to slide ", imageIndex, "for carousel ", carouselId);
    $("#slider-" + carouselId).slick("slickGoTo", imageIndex - 1, false);
  });
});
